import React, {CSSProperties, useEffect, useState} from 'react';
import parse from 'html-react-parser';
import { convertFromHTML, ContentState, EditorState, convertToRaw } from 'draft-js';
import { Editor } from "react-draft-wysiwyg";
import './../tinyEditor.scss';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from 'draftjs-to-html';

interface ITinyEditorLayoutProps {
    data: string
    editState?: boolean
    className?: string
    style?: CSSProperties
    onChange: (content: string) => void
}

const TinyEditorLayout: React.FC<ITinyEditorLayoutProps> = ({
  data,
  onChange,
  className,
  editState,
  style
}) => {

    const [editorState, setEditorState] = useState<EditorState>(EditorState.createEmpty())

    const handleChangeEditor = (content: EditorState) => {
      setEditorState(content)
      const rawContentState = convertToRaw(content.getCurrentContent())
      const markup = draftToHtml(rawContentState)
      onChange && onChange(markup)
    }

    useEffect(() => {
      if(data){
        const blocksFromHTML = convertFromHTML(data)
        const state = ContentState.createFromBlockArray(
          blocksFromHTML.contentBlocks,
          blocksFromHTML.entityMap,
        )
        setEditorState(EditorState.createWithContent(state))
      }
    },[])

    return (
        <div
          className={`tiny_editor-component ${className ? className : ''}`}
          style={style}
        >
            {editState === undefined || editState ?
              <div className="tiny_editor--container">
                <Editor
                  editorClassName='tiny_editor--editor'
                  editorState={editorState}
                  toolbarClassName='tiny_editor--toolbar'
                  onEditorStateChange={handleChangeEditor}
                />
              </div>
            :
              <div className='text-content-tiny' >{data ? parse(data) : ''}</div>
            }
        </div>
    );
};

export default TinyEditorLayout;
